import { type } from './type.js';

/**
 * @description
 * Determines whether the given value is a boolean.
 *
 * @example
 * ``` ts
 * isBoolean(false);
 * // => true
 * isBoolean(() => {});
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns True if the value is a boolean, false otherwise.
 *
 * @docsCategory preference/lang
 * @codeFilter is-boolean
 */
export const isBoolean = (value): value is boolean => {
  return type(value) === 'boolean';
};
